import { render, staticRenderFns } from "./PengaturanAbsensiView.vue?vue&type=template&id=30c5e818&scoped=true"
import script from "./PengaturanAbsensiView.vue?vue&type=script&lang=js"
export * from "./PengaturanAbsensiView.vue?vue&type=script&lang=js"
import style0 from "./PengaturanAbsensiView.vue?vue&type=style&index=0&id=30c5e818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5e818",
  null
  
)

export default component.exports